export const GAIT_TIME_INTERVAL = 1;
export const GAIT_MIN_STEPS = 10;
export const PRESSURE_THRESHOLD = 20;
export const OPTIMAL_GAIT_CYCLE_PCT = 0.61;

export const HIP_ROM_NORMAL_DATA = [25, 20, 10, -4, -19, 10, 29, 25];
export const KNEE_ROM_NORMAL_DATA = [0, 15, 5, -2, 30, 60, 30, 0];
export const ANKLE_ROM_NORMAL_DATA = [0, 5, 10, 12.5, -23, 0, 5, 3];